var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCart03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.2084 14.5833H18.8914C19.9465 14.5833 20.474 14.5833 20.8939 14.3866C21.2639 14.2133 21.5747 13.9351 21.7878 13.5866C22.0296 13.1909 22.0879 12.6666 22.2044 11.6181L22.8138 6.13367C22.8494 5.8134 22.8671 5.65326 22.8156 5.52931C22.7704 5.42045 22.6896 5.33016 22.5864 5.27318C22.4689 5.20831 22.3078 5.20831 21.9855 5.20831H4.68756M2.08325 2.08331H3.38371C3.65936 2.08331 3.79718 2.08331 3.90501 2.13573C3.99994 2.18188 4.0786 2.25579 4.13058 2.34765C4.18963 2.452 4.19823 2.58955 4.21542 2.86466L5.15942 17.9686C5.17661 18.2437 5.18521 18.3813 5.24425 18.4856C5.29624 18.5775 5.3749 18.6514 5.46983 18.6976C5.57765 18.75 5.71548 18.75 5.99113 18.75H19.7916M7.81242 22.3958H7.82284M17.1874 22.3958H17.1978M8.33325 22.3958C8.33325 22.6835 8.10007 22.9166 7.81242 22.9166C7.52477 22.9166 7.29159 22.6835 7.29159 22.3958C7.29159 22.1082 7.52477 21.875 7.81242 21.875C8.10007 21.875 8.33325 22.1082 8.33325 22.3958ZM17.7083 22.3958C17.7083 22.6835 17.4751 22.9166 17.1874 22.9166C16.8998 22.9166 16.6666 22.6835 16.6666 22.3958C16.6666 22.1082 16.8998 21.875 17.1874 21.875C17.4751 21.875 17.7083 22.1082 17.7083 22.3958Z",
    stroke: "#E83E8C",
    strokeWidth: 2.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart03);
export default __webpack_public_path__ + "static/media/shopping-cart-03.4073fa69d3b2f7c1a0a048657b5ba9e3.svg";
export { ForwardRef as ReactComponent };